// extracted by mini-css-extract-plugin
export default {"label-no-equipmet-selected":"label-no-equipmet-selected_GFRYp07R","header-no-selected-equipment-text":"header-no-selected-equipment-text_IY9l6fmS"};